import { render } from "./TotpSettingsView.vue?vue&type=template&id=546538e1&scoped=true"
import script from "./TotpSettingsView.vue?vue&type=script&lang=js"
export * from "./TotpSettingsView.vue?vue&type=script&lang=js"

import "./TotpSettingsView.vue?vue&type=style&index=0&id=546538e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546538e1"]])

export default __exports__